import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./passwordField.css";

const PasswordField = ({
    value,
    onChange,
    placeholder,
    autoComplete = "new-password",
    className = "",
}) => {
    const [show, setShow] = useState(false);

    return (
        <div className="password-wrapper">
            <input
                className={`input ${className}`}
                type={show ? "text" : "password"}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                autoComplete={autoComplete}
            />

            <button
                type="button"
                className="password-toggle"
                onClick={() => setShow(!show)}
            >
                {show ? (
                    <EyeOff size={20} strokeWidth={2} />
                ) : (
                    <Eye size={20} strokeWidth={2} />
                )}
            </button>
        </div>
    );
};

export default PasswordField;
